import type { APIKeys } from "@reducers/actions/apiActions/interface";
import { handleChangesType } from "@src/components/Layout/BookingForm/MainForm/Steps/StepThree/RatesTab/DiscountsTab/discountsLogic";
import { VALID_CARE_PLANS_DISCOUNTS } from "@src/constants";
import { applyCCDiscount } from "@src/utilities/general";
import type { RightioWBSAPIModelsSPSpRFTrackFastJobsGetChargesBookingResult } from "@utils/apis/wbs/model";
import { setRate } from "@utils/charges";
import { state, ui } from "../../../interfaces/interfaces";

const isRateReducedAndNoCC = () => {
	const rateReduction = ui.RatesRateReason;
	return (
		rateReduction?.discountId &&
		rateReduction?.discountId > 0 &&
		!VALID_CARE_PLANS_DISCOUNTS.includes(rateReduction?.discountId || 0)
	);
};

export const apiChargesMiddleware = async (
	action: { payload: { name: APIKeys; value: unknown } },
	next: (action: { payload: { name: APIKeys; value: unknown } }) => unknown,
) => {
	switch (action.payload.name) {
		case "Charge": {
			const value = action.payload.value;
			const charge = Array.isArray(value)
				? (value[0] as RightioWBSAPIModelsSPSpRFTrackFastJobsGetChargesBookingResult)
				: (value as RightioWBSAPIModelsSPSpRFTrackFastJobsGetChargesBookingResult);
			if (charge) {
				const isFixed = charge.price && charge.price > 0;
				if (charge && isFixed) {
					state.IsFixedPrice = true;
				} else {
					state.IsFixedPrice = false;
				}
				charge &&
					isFixed &&
					isRateReducedAndNoCC() &&
					handleChangesType(null, null); // reset rate reduction
				const carePlanReference = ui.CarePlanReference;
				carePlanReference && applyCCDiscount(carePlanReference);
				ui.RatesActiveTab = 0; // fix for fixed price to not attempt to display charge discounts tab
				setRate(charge);
			}

			state[action.payload.name] = charge;

			return next(action);
		}

		default:
			return next(action);
	}
};
